import { Components } from "@thisgorilla/primate-ds";
import { Fragment } from "react";
import styled, { useTheme } from "styled-components";

import { Divider } from "../../../../../commonStyles";

const RenderJsonDynamic = ({ data, title }: { data: any; title: string }) => {
  const { typography, Color } = useTheme();

  const renderContentAccordingType = (data: any) => {
    if (Array.isArray(data)) {
      return (
        <Fragment>
          {data.map((item: any, i: number) => (
            <Fragment key={i}>
              {renderContentAccordingType(item)}
              {Array.isArray(item) && i < data.length - 1 && <Divider />}
            </Fragment>
          ))}
        </Fragment>
      );
    }
    const type = typeof data;
    switch (type) {
      case "number":
      case "string":
        return (
          <ValueContainer>
            <Components.Text
              text={String(data)}
              style={{ tokenStyle: typography.Body.S }}
              color={Color.text["text-emphasize-brand-bolder"].value}
            />
          </ValueContainer>
        );
      case "object":
        const keys = Object.keys(data);
        return (
          <Fragment>
            {keys.map((key, i) => {
              const value = data[key];
              if (typeof value === "object") {
                return <RenderJsonDynamic key={i} data={value} title={key} />;
              }
              return (
                <ValueContainer key={i}>
                  <Components.Text
                    key={i}
                    text={`${key} = ${String(data[key])}`}
                    style={{ tokenStyle: typography.Body.S }}
                    color={Color.text["text-emphasize-brand-bolder"].value}
                  />
                </ValueContainer>
              );
            })}
          </Fragment>
        );
      default:
        return <Fragment />;
    }
  };

  return (
    <SectionContainer>
      <Components.Text
        text={`“${title}”`}
        style={{ tokenStyle: typography.Body.M }}
        color={Color.text["text-secondary"].value}
        fontWeight="font-weight-semibold"
      />

      {renderContentAccordingType(data)}
    </SectionContainer>
  );
};

export default RenderJsonDynamic;

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  gap: ${({ theme }) => theme.spacing["spacing-1"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.elevation.surface["surface-secondary"].value};
`;

const ValueContainer = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    ${({ theme }) => theme.spacing["spacing-05"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background: ${({ theme }) =>
    theme.Color.background.brand.subtlest["default-hover"].value};
`;
